import { Link } from "react-router-dom";
import { rankWeekly } from "@/mocks/rankings";
import SectionHeading from "@/components/base/SectionHeading";
import { formatHeat } from "@/utils/format";

const keywordList = [
  "同框回应",
  "长镜头预告",
  "巡演返场",
  "红毯造型",
  "短剧选角",
  "暑期档复盘",
];

export default function WeeklySection() {
  const maxHeat = Math.max(...rankWeekly.map((item) => item.heat));

  return (
    <section id="weekly" className="scroll-mt-40">
      <SectionHeading
        eyebrow="本周盘点"
        title="一周热点事件汇总"
        desc="把过去七天的讨论量加总排序，看清楚哪些话题是真正的长线焦点。"
        moreText="查看完整盘点"
        morePath="/ranking"
      />

      <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
        <div className="rounded-card border border-background-200/80 bg-background-50 p-5 md:p-6 lg:col-span-2">
          <div className="flex flex-col gap-5">
            {rankWeekly.map((item) => (
              <Link key={item.slug} to={`/article/${item.slug}`} className="group block">
                <div className="flex items-center justify-between gap-4">
                  <span className="flex min-w-0 items-center gap-3">
                    <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-md bg-background-200 text-xs font-bold text-foreground-700">
                      {item.rank}
                    </span>
                    <span className="truncate text-sm font-medium text-foreground-900 transition-colors duration-200 group-hover:text-primary-700">
                      {item.title}
                    </span>
                  </span>
                  <span className="shrink-0 text-xs font-medium text-foreground-500">
                    {formatHeat(item.heat)}
                  </span>
                </div>
                <div className="mt-2.5 h-2 w-full overflow-hidden rounded-full bg-background-200/80">
                  <div
                    className={`h-full rounded-full ${
                      item.rank <= 3 ? "bg-primary-500" : "bg-secondary-500"
                    }`}
                    style={{ width: `${Math.round((item.heat / maxHeat) * 100)}%` }}
                  ></div>
                </div>
              </Link>
            ))}
          </div>
        </div>

        <aside className="flex flex-col gap-6">
          <div className="rounded-card border border-background-200/80 bg-accent-50 p-5">
            <h3 className="flex items-center gap-2 font-heading text-sm font-bold text-foreground-950">
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-price-tag-3-line text-accent-700"></i>
              </span>
              本周关键词
            </h3>
            <ul className="mt-4 flex flex-wrap gap-2">
              {keywordList.map((word) => (
                <li
                  key={word}
                  className="rounded-full border border-accent-300/70 bg-background-50 px-3 py-1 text-xs text-accent-900"
                >
                  {word}
                </li>
              ))}
            </ul>
            <p className="mt-4 text-xs leading-relaxed text-foreground-600">
              关键词来自本周合集的高频讨论点，点击榜单可以查看对应话题的时间线。
            </p>
          </div>

          <div className="rounded-card border border-background-200/80 bg-secondary-900 p-5 text-secondary-50">
            <h3 className="font-heading text-sm font-bold">榜单更新说明</h3>
            <p className="mt-2 text-xs leading-relaxed text-secondary-100/80">
              总榜每两小时刷新，周榜每周一上午 10:00 结算。新晋榜收录近三天首次进入前二十的话题。
            </p>
            <Link
              to="/ranking"
              className="mt-4 inline-flex items-center gap-1 whitespace-nowrap rounded-full bg-accent-500 px-4 py-2 text-xs font-medium text-secondary-950 transition-colors duration-200 hover:bg-accent-400"
            >
              切换查看其他榜单
              <span className="flex h-3.5 w-3.5 items-center justify-center">
                <i className="ri-arrow-right-line text-[13px]"></i>
              </span>
            </Link>
          </div>
        </aside>
      </div>
    </section>
  );
}